/**
 * G4-T25.8: Bekleyen sync öğelerini gösteren küçük rozet.
 * Sağ alt köşede sabit konumda görünür; bekleyen öğe yoksa gizlenir.
 */
import React, { useState, useEffect } from 'react';
import syncManager from '../utils/syncManager';

const POLL_MS = 5_000;

export default function SyncStatusBadge() {
  const [pending, setPending] = useState(0);
  const syncing = false;

  useEffect(() => {
    let timer;

    async function refresh() {
      const count = await syncManager.getPendingCount();
      setPending(count);
    }

    refresh();
    timer = setInterval(refresh, POLL_MS);
    return () => clearInterval(timer);
  }, []);

  // Gönderilecek öğe yoksa gösterme
  if (pending === 0 && !syncing) return null;

  return (
    <div
      title={`${pending} öğe senkronizasyon bekliyor`}
      style={{
        position:     'fixed',
        bottom:       16,
        right:        16,
        background:   syncing ? 'var(--accent)' : '#64748b',
        color:        '#fff',
        borderRadius: '999px',
        padding:      '5px 12px',
        fontSize:     '0.78rem',
        fontWeight:   600,
        boxShadow:    '0 2px 8px rgba(0,0,0,0.25)',
        zIndex:       9999,
        cursor:       'default',
        userSelect:   'none',
      }}
    >
      {syncing ? 'Senkronize ediliyor…' : `${pending} bekliyor`}
    </div>
  );
}
